export const toYouTubeEmbedUrl = url => {
  try {
    const u = new URL(url);
    const videoId =
      u.hostname === "youtu.be"
        ? u.pathname.slice(1)
        : u.searchParams.get("v");
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  } catch (e) {
    return url;
  }
};
